import { styled } from "styled-components";
const TabBarFinal = styled("div")({
  alignItems: "center",
  alignSelf: "stretch",
  display: "flex",
  marginLeft: "auto",
  padding: "0 8px 1px 16px",
  flex: "0 0 auto"
});
export {
  TabBarFinal
};
